import { useEffect, useState } from "react";

import { useDispatch, useSelector } from "react-redux";

import { selectUserState, fetchInit } from "@state/userSlice/userSlice";

import type { AppDispatch } from "@state/store";

export const useAppInitialization = () => {
  const dispatch = useDispatch<AppDispatch>();
  const [initialized, setInitialized] = useState(false);

  // prettier-ignore
  const { accountId, userId, onboardingStep } = useSelector(selectUserState);

  useEffect(() => {
    async function initializeApp() {
      try {
        const token = localStorage.getItem("token");

        if (!token) {
          setInitialized(true);
          return;
        } else {
          await dispatch(fetchInit({})).unwrap();
          setInitialized(true);
        }
      } catch {
        setInitialized(true);
      }
    }

    initializeApp();
  }, [dispatch]);

  return {
    isLoading: !initialized,
    accountId,
    userId,
    onboardingStep,
  };
};
